// extracted by mini-css-extract-plugin
export var buttonWrapper = "styles-module--button-wrapper--6c216";
export var form = "styles-module--form--97833";
export var formWrapper = "styles-module--form-wrapper--9825b";
export var input = "styles-module--input--17238";